<template>
    <a-popover :placement="props.placement" :open="state.popoverVisible" :overlayInnerStyle="{
        padding: '25px',
        width: '860px',
        maxWidth: '900px',
        minHeight: '380px'
    }" @openChange="handleOpenChange">
        <template #content>
            <div v-if="!state.loading && record.id > 0" style="width: 100%;">
                <a-watermark :content="'信息确认单 ' + (record.seller || record.ludan_name || '')" :gap="[150, 150]"
                    fontWeight="light">
                    <div style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px"
                        @click="copydetailinfo(record)">
                        主体名称: {{ record.full_name
                        }}<a-tag style="font-weight: normal"
                            :color="['非正常户注销', '注销'].includes(record.tax_status_name) ? 'red' : 'green'"
                            v-if="record.tax_status != 7">{{ record.tax_status_name }}
                            税务状态更新时间：{{
                                record.tax_check_time }}<span v-if="record.tax_type == 2">一般人认定时间：{{
                                record.tax_ybr_time
                            }}</span>
                        </a-tag>
                    </div>
                    <div style="margin: 6px 0">地址：{{ record.full_address_number }}</div>
                    <div style="margin: 6px 0" class="d-flex" v-if="record.history_names?.length > 0">
                        <div>历史申请：</div>
                        <div>
                            <div v-for="(item, index) in record.history_names" :key="index">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                    <div style="margin: 6px 0" v-if="record.social_credit_code?.length > 0">
                        统一社会信用代码：{{ record.social_credit_code }}</div>
                    <div style="margin: 6px 0">
                        <span class="mr-2x">入驻时间：{{ record.enter_starttime?.substr(0, 10) || '-' }}
                            <span class="mv-1x">~</span> {{ record.enter_endtime?.substr(0, 10) || '-' }}
                            <span v-if="enterTime(record.enter_endtime) && record.fee_standard == 1" class="red">（{{
                                enterTime(record.enter_endtime) }}）</span>
                            <a-tag color="green">{{ record.fee_standard == 1 ? '按年续费' :
                                record.fee_standard == 2 ? '一次性付费' : '未知付费方式' }}</a-tag>
                            <a-tag color="blue" v-if="record.is_ybr == 1">一般纳税人</a-tag>
                        </span>
                        <span class="mr-2x" v-if="record.tyc_update_time">
                            <SyncOutlined style="color: #1677ff" /> {{ record.tyc_update_time
                            }}更新
                        </span>
                    </div>
                    <div style="margin: 6px 0">
                        <span v-if="record.verify_time" class="mr-2x">核准日期：{{
                            record.verify_time?.substr(0, 10) || '-' }} </span>
                        <span v-if="record.founding_time" class="mr-2x"> 成立日期：{{
                            record.founding_time?.substr(0, 10) || '-' }} </span>
                        <span v-if="record.created_at"> 录入系统时间：{{ record.created_at }} </span>
                    </div>
                    <div style="margin: 6px 0">
                        <p class="mr-2x">
                            工商预留手机号码：<span style="color: red">{{ record.registration_mobile || '-' }}</span>
                            <a v-if="record.registration_mobile"
                                @click="onUsbphoneClick(record, record.registration_mobile)">
                                <PhoneOutlined />
                            </a>
                        </p>
                    </div>
                    <div style="margin: 6px 0; max-width: 800px">
                        <span class="mr-2x">经营范围：<span v-html="record.business_scope || '-'"></span>
                        </span>
                    </div>
                    <div style="margin: 16px 0">
                        <a-table :columns="shareholderColumns" size="small" rowKey="name" :pagination="false"
                            :data-source="record.shareholder_list || []">
                            <template #bodyCell="res">
                                <template v-if="res.column.dataIndex == 'name'">
                                    <div>
                                        <div class="tablewraptr">
                                            {{ res.text }}
                                            <a-tag :color="res.record.hehuo_type == 1 ? 'blue' : 'green'"
                                                v-if="record.main_type == 4 && (res.record.type == 2 || res.record.is_shareholder == 1)">{{
                                                    res.record.hehuo_type == 1 ? '有限合伙人' : '普通合伙人'
                                                }}</a-tag>
                                            <span class='onekeylimited'>
                                                <a-popconfirm v-if="user.id == 1"
                                                    :title="`您确定将'${res.record.name}'限制入驻吗?`" placement="top"
                                                    @confirm="onekeylimit(res.record)">
                                                    <a>限制入驻</a></a-popconfirm>
                                            </span>
                                        </div>
                                        <div v-if="record.permission_look_gd_tel == 1 && res.record.phone_number">
                                            本人工商预留电话：{{
                                                res.record.phone_number }}
                                            <a @click="onUsbphoneClick(record, res.record.phone_number)">
                                                <PhoneOutlined />
                                            </a>
                                        </div>
                                        <div
                                            v-if="record.permission_look_gd_tel == 1 && res.record.phone_number_fengkong">
                                            实名风控电话：{{
                                                res.record.phone_number_fengkong }}
                                            <a @click="onUsbphoneClick(record, res.record.phone_number_fengkong)">
                                                <PhoneOutlined />
                                            </a>
                                        </div>
                                        <div v-if="res.record.id_card_number">
                                            <a v-if="res.record.id_card_number_show == 1"
                                                @click="idCardNumberClick(res.record, 0)" style="color:black">
                                                {{ res.record.id_card_number }}
                                                <EyeInvisibleOutlined />
                                            </a>
                                            <a v-else @click="idCardNumberClick(res.record, 1)" style="color:black">
                                                {{ res.record.id_card_number?.substr(0, 3) +
                                                    '********' +
                                                    res.record.id_card_number?.substr(15) }}
                                                <EyeOutlined />
                                            </a>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="res.column.dataIndex == 'address'">
                                    <div>{{ res.record.address || '-' }}</div>
                                    <div v-if="res.record.type == 1">
                                        <a-button v-if="res.record.showidcard" @click="res.record.showidcard = 0"
                                            style="display: block; padding: 0" type="link">查看身份证照片</a-button>
                                    </div>
                                    <div v-if="res.record.type == 2">
                                        <a-button v-if="res.record.showidcard" @click="res.record.showidcard = 0"
                                            style="display: block; padding: 0" type="link">查看营业执照照片</a-button>
                                    </div>
                                    <div v-if="!res.record.showidcard && res.record.type == 1">
                                        <b-image :width="100"
                                            :src="$store.state.user.image_domain + res.record.id_card_back"></b-image>
                                        <b-image :width="100"
                                            :src="$store.state.user.image_domain + res.record.id_card_front"></b-image>
                                    </div>
                                    <div v-if="!res.record.showidcard && res.record.type == 2">
                                        <b-image :width="100"
                                            :src="$store.state.user.image_domain + res.record.business_license_url"></b-image>
                                    </div>
                                </template>
                                <template v-if="res.column.dataIndex == 'position_name'">
                                    <div v-if="record.main_type == 1" style="max-width: 230px">
                                        <div v-if="res.text">
                                            <span v-for="(item, index) in res.text.split(',')" :key="index">
                                                <a-tag v-if="item?.length > 0" color="cyan">{{
                                                    record.is_filiale == 1 ?
                                                        item.replace(/法定代表人/g, '负责人') : item
                                                }}</a-tag>
                                            </span>
                                        </div>
                                        <div v-else>-</div>
                                    </div>
                                    <div v-else-if="record.main_type == 4" style="max-width: 230px">
                                        <div v-if="res.text">
                                            <span
                                                v-for="(item, index) in res.text.replace('法定代表人', '执行事务合伙人').split(',')"
                                                :key="index">
                                                <a-tag v-if="item?.length > 0" color="cyan">{{
                                                    item
                                                }}</a-tag>
                                            </span>
                                        </div>
                                        <div v-else>-</div>
                                    </div>
                                    <div v-else>
                                        <a-tag color="cyan">负责人</a-tag>
                                    </div>
                                </template>
                                <template v-else-if="res.column.dataIndex == 'investment_money'">
                                    <div v-if="res.record.is_shareholder == 1">{{ res.text
                                    }}<span v-if="res.text">万元</span>
                                    </div>
                                    <div v-else>-</div>
                                </template>
                                <template v-else-if="res.column.dataIndex == 'subscribe_endtime'">
                                    <div
                                        v-if="(record.main_type == 1 || record.main_type == 4) && res.record.is_shareholder == 1">
                                        <span v-if="record.is_filiale != 1">{{
                                            res.text?.substr(0, 10) || '-' }}</span>
                                    </div>
                                    <div v-else>-</div>
                                </template>
                            </template>
                        </a-table>
                    </div>
                </a-watermark>
            </div>
            <!-- 加载中：只显示loading状态，不显示骨架屏 -->
            <div v-else
                style="min-height: 380px; display: flex; align-items: center; justify-content: center; width: 100%;">
                <a-spin :spinning="true" tip="加载中..." />
            </div>
        </template>
        <a type="primary" @mouseenter="handleMouseEnter">更多信息</a>
    </a-popover>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { EyeOutlined, EyeInvisibleOutlined, SyncOutlined, PhoneOutlined } from '@ant-design/icons-vue'
import { reactive, onMounted, ref, nextTick } from 'vue'
import dayjs from 'dayjs'
import BImage from '@/components/sourceImg/BImage.vue'
import { useStore } from 'vuex'
const $store = useStore()
import ls from '@/utils/Storage'
const user = ls.get('USER_INFO')

const props = defineProps({
    customerData: {
        type: Object,
        default: () => ({})
    },
    placement: {
        type: String,
        default: 'right'
    }
})
interface IState {
    loading: boolean
    popoverVisible: boolean
    dataLoaded: boolean
}
const state = reactive<IState>({
    loading: false,
    popoverVisible: false,
    dataLoaded: false
})
const record = reactive<any>({})
let isDataReady = ref(false) // 数据是否已准备好
let pendingOpen = ref(false) // 是否有待打开的弹窗

// 鼠标悬停：先请求数据，数据回来后再打开弹窗
const handleMouseEnter = () => {

    // 如果正在加载中，不重复请求
    if (state.loading) {
        return
    }
    // 开始加载数据
    state.loading = true
    // 不立即打开弹窗，等数据回来
    pendingOpen.value = true

    let requeryParam = {
        url: `/admin/v1/customerMoreInfo/${props.customerData.id}`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            // 格式化时间字段
            if (res.data.created_at) {
                res.data.created_at = dayjs(res.data.created_at).format('YYYY-MM-DD HH:mm:ss')
            }
            if (res.data.tyc_update_time) {
                res.data.tyc_update_time = dayjs(res.data.tyc_update_time).format('YYYY-MM-DD HH:mm:ss')
            }
            if (res.data.tax_check_time) {
                res.data.tax_check_time = dayjs(res.data.tax_check_time).format('YYYY-MM-DD HH:mm:ss')
            }
            if (res.data.tax_ybr_time) {
                res.data.tax_ybr_time = dayjs(res.data.tax_ybr_time).format('YYYY-MM-DD HH:mm:ss')
            }
            Object.assign(record, res.data)
            state.dataLoaded = true
            // 数据加载完成，打开弹窗
            if (pendingOpen.value) {
                state.popoverVisible = true
                pendingOpen.value = false
            }
        })
        .finally(() => {
            state.loading = false
        })
}

const handleOpenChange = (visible: boolean) => {
    if (!visible) {
        // 弹窗关闭时重置状态
        state.popoverVisible = false
        pendingOpen.value = false
    }
}

const copydetailinfo = (record) => {
    const content = `待注册主体信息如下：
公司名称：${record.full_name || '-'}
工商预留手机号码：${record.registration_mobile || '-'}
经营范围：${record.business_scope || '-'}

股东信息及占股比例如下：
${(record.shareholder_list || []).map(item => {
        let partnerType = ''
        if (record.main_type == 4 && (item.type == 2 || item.is_shareholder == 1)) {
            partnerType = item.hehuo_type == 1 ? '（有限合伙人）' : '（普通合伙人）'
        }
        const subscribeDate = item.subscribe_endtime?.split(' ')[0] || item.subscribe_endtime
        const positionText = item.position_name ? `担任职位：${item.position_name}` : ''
        return `${item.name}${partnerType} ${item.id_card_number || ''} ${item.address || ''} 资本：${item.investment_money || 0}万 期限：${subscribeDate || '-'} ${positionText}`.trim()
    }).join('\r\n\r\n')}
`
    navigator.clipboard.writeText(content)
    message.success('复制成功!')
}
const formatDuration = (duration: number) => {
    const days: any = Math.floor(duration / (24 * 60 * 60))
    if (days > 0 && days <= 30) {
        return '到期前30天内'
    } else if (days > 30 && days <= 60) {
        return '到期前60天内'
    } else if (days < 0 && days >= -30) {
        return '到期后30天内'
    } else if (days < -30 && days >= -60) {
        return '到期后60天内'
    } else if (days < -60 && days >= -90) {
        return '到期后90天内'
    } else if (days < -90) {
        return '到期90天后客户,即将申报工商地址异常'
    } else {
        return null
    }
}
const enterTime = (endtime) => {
    if (!endtime) return null
    const start = dayjs(endtime)
    const end = dayjs()
    const duration = start.diff(end, 'second')
    return formatDuration(duration)
}
const onUsbphoneClick = (record, phone) => {
    if (!phone) return
    $store.dispatch('usbphone/AddPhoneModal', {
        phone: phone,
        customer_id: record.id,
        full_name: record.full_name
    })
    if (record) {
        record.sellerPhonePopover = false
        record.xftelPhonePopover = false
    }
}
const shareholderColumns: Object[] = [
    {
        title: '姓名、身份标识、手机号码',
        dataIndex: 'name'
    },
    {
        title: '照片',
        dataIndex: 'address',
        width: 200
    },
    {
        title: '职位',
        dataIndex: 'position_name'
    },
    {
        title: '出资金额',
        dataIndex: 'investment_money'
    },
    {
        title: '认缴出资日期',
        dataIndex: 'subscribe_endtime'
    }
]
const idCardNumberClick = (record, status) => {
    record.id_card_number_show = status
    var input = document.createElement('input')
    input.value = record.id_card_number || ''
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    message.success('复制成功！')
    document.body.removeChild(input)
}
const onekeylimit = (record) => {
    let requestParam = {
        url: '/admin/v1/onekeylimit',
        method: 'post',
        data: { data: record }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
</script>
<style lang="less" scoped>
.tablewraptr {
    .onekeylimited {
        display: none;
    }
}

.tablewraptr:hover {
    .onekeylimited {
        display: inline-block;
    }
}
</style>
